import React from "react";
import PropTypes from "prop-types";
import { CLabel } from "@appcues/component-library";

const ARCHIVED = "archived";
const DRAFT = "draft";
const LIVE = "live";

export default function PublishStatusTag({ published, state, ...props }) {
  const type =
    state.toLowerCase() === ARCHIVED ? ARCHIVED : published ? LIVE : DRAFT;

  return <CLabel type={type} {...props} />;
}

PublishStatusTag.propTypes = {
  published: PropTypes.bool,
  state: PropTypes.oneOf(["", ARCHIVED, DRAFT, LIVE])
};

PublishStatusTag.defaultProps = {
  published: false,
  state: ""
};
